import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { Constantes } from '../../shared/constantes';

@Injectable()
export class ReCaptchaService {
  api: string;
  servicio: string;

  constructor(private httpClient: HttpClient) {
    this.api = environment.api;
    this.servicio = Constantes.SERVICIO_RECAPTCHA;
  }

  getSiteKey(): Observable<string> {
    return this.httpClient.get<string>(this.api + this.servicio + 'siteKey');
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/services/re-captcha.service.ts